 
 
 
 
 
 
define([], function() {
    'use strict';

    var ObjectModel = function() {  
 
 
 
 
 
/**
 * @ignore
 * Objects of this class represent Html elements with folding/wraping functionality
 */
/* jshint nomen:false */
define([], function() {
    'use strict';

    function Wrapable(htmlElement, wrapFunction) {
        this._htmlElement = htmlElement;
        this._wrapFunction = wrapFunction;
    }

    /**
     * @ignore
     * @return {HtmlElement}
     */
    Wrapable.prototype.getHtmlElement = function() {
        return this._htmlElement;
    };

    /**
     * @ignore
     *  Wraps/folds element
     */
    Wrapable.prototype.wrap = function() {
        this._wrapFunction(this._htmlElement);
    };

    return Wrapable;

});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/wrapable.js